import { assetAllocationPages } from "@app/const/route.const";
import { AssetAllocationDashboardPage } from "./dashboard/AssetAllocationDashboardPage";
import { EditPortfolioGroupPage } from "./editPortfolioGroup/EditPortfolioGroupPage";
import { ViewPortfolioGroupPage } from "./viewPortfolioGroup/ViewPortfolioGroupPage";
import { AccessRouteControl } from "@app/components/AccessRouteControl";
import { CarModuleSectionCode } from "@app/hooks/useUserAccess";
import { PdfAssetAllocationSummaryReportPage } from "@app/pages/assetAllocation/pdfSummaryReport/PdfAssetAllocationSummaryReportPage";
import { PdfPortfolioGroupPublishReportPage } from "./pdfPportfolioGroupPublishReport/PdfPortfolioGroupPublishReportPage";
import { PdfAssetAllocationModuleSummaryReportPage } from "./pdfModuleSummaryReport/PdfAssetAllocationModuleSummaryReportPage";
import { PdfAssetAllocationModulePerformanceRiskReportPage } from "./pdfModulePerformanceRiskReport/PdfAssetAllocationModulePerformanceRiskReportPage";
import { PdfAssetAllocationModuleMultiPeriodReturnReportPage } from "./pdfModuleMultiPeriodReturnReport/PdfAssetAllocationModuleMultiPeriodReturnReportPage";
import { PdfAssetAllocationModuleSimulatedForwardProbabilitiesReportPage } from "./pdfModuleSimulatedForwardProbabilitiesReport/PdfAssetAllocationModuleSimulatedForwardProbabilitiesReportPage";
import { PdfAssetAllocationModuleScenarioAnalysisReportPage } from "./pdfModuleScenarioAnalysisReport/PdfAssetAllocationModuleScenarioAnalysisReportPage";
import { PdfAssetAllocationModuleSectorAnalysisReportPage } from "./pdfModuleSectorAnalysisReport/PdfAssetAllocationModuleSectorAnalysisReportPage";

export const AssetAllocationPage = () => {
  return (
    <AccessRouteControl
      items={[
        {
          path: assetAllocationPages.dashboard,
          element: <AssetAllocationDashboardPage />,
          moduleSection: CarModuleSectionCode.ASSET_ALLOCATION_DASHBOARD,
        },
        {
          path: assetAllocationPages.editPortfolioGroup,
          element: <EditPortfolioGroupPage />,
          moduleSection:
            CarModuleSectionCode.ASSET_ALLOCATION_EDIT_PORTFOLIO_GROUP,
        },
        {
          path: assetAllocationPages.viewPortfolioGroup,
          element: <ViewPortfolioGroupPage />,
          moduleSection:
            CarModuleSectionCode.ASSET_ALLOCATION_VIEW_PORTFOLIO_GROUP,
        },
        {
          path: assetAllocationPages.pdfSummaryReportPath,
          element: <PdfAssetAllocationSummaryReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_ASSET_ALLOCATION_SUMMARY_REPORT,
        },
        {
          path: assetAllocationPages.pdfModuleSummaryReportPath,
          element: <PdfAssetAllocationModuleSummaryReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_ASSET_ALLOCATION_MODULE_SUMMARY_REPORT,
        },
        {
          path: assetAllocationPages.pdfModulePerformanceRiskReportPath,
          element: <PdfAssetAllocationModulePerformanceRiskReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_ASSET_ALLOCATION_MODULE_PERFORMANCE_RISK_REPORT,
        },
        {
          path: assetAllocationPages.pdfModuleMultiPeriodReturnReportPath,
          element: <PdfAssetAllocationModuleMultiPeriodReturnReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_ASSET_ALLOCATION_MODULE_MULTI_PERIOD_RETURN_REPORT,
        },
        {
          path: assetAllocationPages.pdfModuleSimulatedForwardProbabilitiesReportPath,
          element: (
            <PdfAssetAllocationModuleSimulatedForwardProbabilitiesReportPage />
          ),
          moduleSection:
            CarModuleSectionCode.PDF_ASSET_ALLOCATION_MODULE_SIMULATED_FORWARD_PROBABILITIES_REPORT,
        },
        {
          path: assetAllocationPages.pdfModuleScenarioAnalysisReportPath,
          element: <PdfAssetAllocationModuleScenarioAnalysisReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_ASSET_ALLOCATION_MODULE_SCENARIO_ANALYSIS_REPORT,
        },
        {
          path: assetAllocationPages.pdfModuleSectorAnalysisReportPath,
          element: <PdfAssetAllocationModuleSectorAnalysisReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_ASSET_ALLOCATION_MODULE_SECTOR_ANALYSIS_REPORT,
        },

        // deprecated
        {
          path: assetAllocationPages.pdfPortfolioGroupPublishReportPath,
          element: <PdfPortfolioGroupPublishReportPage />,
          moduleSection:
            CarModuleSectionCode.PDF_PORTFOLIO_GROUP_PUBLISH_REPORT,
        },
      ]}
      defaultPath={assetAllocationPages.dashboard}
    />
  );
};
